module.exports = __webpack_public_path__ + "img/1927_1932-Nixon cases.f31c90e4.png";